// extracted by mini-css-extract-plugin
export default {"FolderSVG":"RJ6_P"};